import script from "./PageSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageSelector.vue?vue&type=script&setup=true&lang=ts"

import "./PageSelector.vue?vue&type=style&index=0&id=3bd598fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd598fa"]])

export default __exports__